import type { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
// Import Swiper styles
import 'swiper/css';

import 'swiper/css/effect-fade';

interface gallerySwiperProps {
  collections: Array<any>;
}

const CollectionsSwiper: FC<gallerySwiperProps> = ({ collections }) => {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        effect="fade"
        autoplay={{ delay: 1000 }}
        loop={true}
        speed={1000}
        modules={[Autoplay, EffectFade]}
      >
        {collections.map((collection, index) => (
          <SwiperSlide key={index}>
            <div
              onClick={() => navigate('/files', { state: collection.path })}
              className="relative w-full group cursor-pointer h-[250px] overflow-hidden rounded-sm md:h-[350px] lg:h-[420px] xl:h-[520px]"
            >
              <img
                className="absolute top-0 left-0 object-cover object-center w-full h-full"
                src={collection.image}
                alt={collection.title}
              />
              <div className="absolute w-full h-full transition-all bg-text/10 group-hover:bg-text/45" />
              <h3 className="absolute left-8 bottom-8 text-3xl font-semibold text-white transition-all md:text-5xl">
                {collection.title}
              </h3>
              <svg
                className="absolute right-8 bottom-8 h-5 w-7 stroke-accent transition-transform group-hover:translate-x-1"
                viewBox="0 0 25 19"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M2.43555 1.75977C2.43555 1.20748 1.98783 0.759766 1.43555 0.759766C0.883262 0.759766 0.435547 1.20748 0.435547 1.75977H2.43555ZM24.1427 11.4669C24.5332 11.0763 24.5332 10.4432 24.1427 10.0527L17.7787 3.6887C17.3882 3.29817 16.755 3.29817 16.3645 3.6887C15.974 4.07922 15.974 4.71239 16.3645 5.10291L22.0213 10.7598L16.3645 16.4166C15.974 16.8071 15.974 17.4403 16.3645 17.8308C16.755 18.2214 17.3882 18.2214 17.7787 17.8308L24.1427 11.4669ZM0.435547 1.75977V3.4681H2.43555V1.75977H0.435547ZM0.435547 3.4681C0.435547 4.77333 0.434364 5.94912 0.538535 6.94398C0.642813 7.93987 0.862157 8.87652 1.38592 9.65602C2.48331 11.2892 4.56256 11.7598 7.67879 11.7598V9.75977C4.55178 9.75977 3.50941 9.23029 3.04599 8.54059C2.78934 8.15864 2.61848 7.6031 2.52766 6.7357C2.43673 5.86729 2.43555 4.80871 2.43555 3.4681H0.435547ZM7.67879 11.7598H23.4355V9.75977H7.67879V11.7598Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default CollectionsSwiper;
